import Controller from 'controllers/controller';
import Elements from 'tools/elements';

import jQuery from 'jquery';
import $ from 'jquery';

window.$ = window.jQuery = jQuery;

/**
 * @class CarouselsController - This controller finds carousels on the page, and initialises individual
 * CarouselController classes for each.
 */
class BlogController extends Controller {
    ready() {
        this.elements = new Elements;

        this.cacheElements();

        window.addEventListener('load', this.init);
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('load', this.onScroll);
        window.addEventListener('resize', this.onScroll);
//        window.addEventListener('scroll', this.onScroll);
    }

    init() {
        if (this.elements.get('blog-categories-select').length > 0) {
            this.attachEvents();
        }
    }

    cacheElements() {
        this.elements.queryAll('blog-categories-select', '.blog-categories-select');
        this.elements.queryAll('blog-search-form', '.blog-search-input form');
        this.elements.queryOne('blog-post-content', '.blog-post .post-content');
        this.elements.queryOne('blog-recent-posts-container', '.blog-post .recent-posts-container');
        this.elements.queryOne('blog-recent-posts', '.blog-post .recent-posts');
        this.elements.queryOne('header', 'header#header');
        this.elements.queryOne('footer', 'footer#footer');
    }

    attachEvents() {
        this.elements.each('blog-categories-select', select => select.addEventListener('change', this.onChange));
        this.elements.each('blog-search-form', form => {
            const button = this.elements.queryOne('blog-search-button', '.button', form);
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const input = this.elements.queryOne('blog-search-input', 'input', form);
                if (input.value === '') {
                    alert('Please enter a word or phrase to search for');
                    input.focus();
                }
                else {
                    console.log('Submitting search form...');
                    form.submit();
                }
            });
        });
    }

    onChange(event) {
        event.preventDefault();
        window.location.href = event.target.value;
    }

    onScroll() {
        if (typeof this.elements.get('blog-post-content') === 'undefined' || this.elements.get('blog-post-content').getBoundingClientRect().height < this.elements.get('blog-recent-posts-container').getBoundingClientRect().height) {
            return;
        }
        
        let header = this.elements.get('header').getBoundingClientRect(),
            footer = this.elements.get('footer').getBoundingClientRect(),
            container = this.elements.get('blog-recent-posts-container').getBoundingClientRect(),
            recentPosts = this.elements.get('blog-recent-posts').getBoundingClientRect();

        if (container.y - header.height <= 0 && header.height + recentPosts.height + 60 < footer.y) {
            this.addFixed();
        }
        else if (header.height + recentPosts.height + 60 >= footer.y) {
            this.addBottom();
        }
        else {
            this.removeFixed();
            this.removeBottom();
        }
    }

    isFixed() {
        return this.elements.get('blog-recent-posts-container').classList.contains('fixed');
    }

    isBottom() {
        return this.elements.get('blog-recent-posts-container').classList.contains('bottom');
    }

    addFixed() {
        if (! this.isFixed()) {
            this.elements.get('blog-recent-posts-container').classList.add('fixed');
            
            let width = this.elements.get('blog-recent-posts-container').getBoundingClientRect().width;
            if (width > 0) {
                this.elements.get('blog-recent-posts').style.width = `${width}px`;
            }
        }
        this.removeBottom();
    }
    
    removeFixed() {
        if (this.isFixed()) {
            this.elements.get('blog-recent-posts-container').classList.remove('fixed');
            this.elements.get('blog-recent-posts').style.width = null;
        }
    }

    addBottom() {
        if (! this.isBottom()) {
            this.elements.get('blog-recent-posts-container').classList.add('bottom');
        }
        this.removeFixed();
    }
    
    removeBottom() {
        if (this.isBottom()) {
            this.elements.get('blog-recent-posts-container').classList.remove('bottom');
        }
    }
}

export default BlogController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/blog.js